import React, { useRef, useState } from 'react'
import cn from 'classnames'

import { ReactComponent as Chevron } from '../../../assets/icons/chevron.svg'
import { ReactComponent as Trash } from '../../../assets/icons/trash.svg'

import { clearSuffix } from '../../../utils/functions'

import './FilterSelect.scss'

const PANEL_MAX_HEIGHT = 650
const LIST_ITEM_HEIGHT = 46

export const FilterSelect = ({
  label = '',
  config,
  list,
  selected = [],
  onChange,
}) => {
  const [show, setShow] = useState(false)
  const panelRef = useRef()

  const select = v => () => {
    setShow(false)
    onChange(v)
  }

  const calcHeight = () => {
    if (!show) return 0

    const docHeight = document.body.offsetHeight - 30
    const top = panelRef.current.getBoundingClientRect().top + document.documentElement.scrollTop
    const list = listItems.length * LIST_ITEM_HEIGHT + 2
    const panelHeight = list > PANEL_MAX_HEIGHT ? PANEL_MAX_HEIGHT : list

    return top + panelHeight > docHeight ? docHeight - top: panelHeight
  }

  let listItems = []
  if (list)
    listItems = list.map((item, i) => (
      <button
        key={ i }
        className={cn({ selected: i === selected })}
        onClick={ select(i) }
      >
        <span>
          { clearSuffix(item, 'CoolCat') }
        </span>
        <div className="icons">
          { i === selected && <Trash className="trash" /> }
        </div>
      </button>
    ))

  if (config) {
    Object.keys(config)
      .sort()
      .forEach(key => {
        const value = config[key]
        const sel = selected.includes(key)
        listItems.push(
          <button
            key={ key }
            className={cn({ selected: sel })}
            onClick={ select(key) }
          >
            <span>
              { clearSuffix(key, 'CoolCat') }
            </span>
            <div className="icons">
              { sel && <Trash className="trash" /> }
              <span>
                { value }
              </span>
            </div>
          </button>
        )
      })
  }

  return (
    <div className={cn( 'filter-select-container', { show } )}>
      <button
        className={cn({ selected: config ? selected.length : selected > -1 })}
        onClick={() => setShow(v => !v)}
      >
        <span>
          { label }
        </span>
        <Chevron />
      </button>
      <div
        ref={ panelRef }
        className="list-wrapper"
        style={{ height: calcHeight() }}
      >
        <div className="list">
          { listItems }
        </div>
      </div>
      <div
        className="global-wrapper"
        onClick={() => setShow(false)}
      ></div>
    </div>
  )
}